import { RootPaths } from "@src/appV2/App/paths";
import { Route, Switch } from "react-router-dom";

import { InHomeCaseHistoryDataProvider } from "../ShiftDiscovery/useInHomeCaseHistoryDataContext";
import { InHomeVisitModalsDataProvider } from "../ShiftDiscovery/useInHomeVisitModalsDataContext";
import { BookedVisitDetailsPage } from "./BookedVisitDetails/BookedVisitDetailsPage";
import { BookedVisitModalRoutes } from "./BookedVisitModalRoutes";
import { CaseHistoryPage } from "./CaseHistory/Page";
import { CaseHistoryModalRoutes } from "./CaseHistoryModalRoutes";
import { BOOKED_VISIT_DETAILS_PATH, IN_HOME_BOOKED_VISIT_HISTORY_PATH } from "./paths";

export function InHomeRouter() {
  return (
    <InHomeVisitModalsDataProvider baseNavigationPath={`${RootPaths.APP_V2_HOME}`}>
      <InHomeCaseHistoryDataProvider baseNavigationPath={`${RootPaths.APP_V2_HOME}`}>
        <BookedVisitModalRoutes />
        <CaseHistoryModalRoutes />

        <Switch>
          <Route
            path={`${RootPaths.APP_V2_HOME}/${BOOKED_VISIT_DETAILS_PATH}`}
            component={BookedVisitDetailsPage}
          />
          <Route
            path={`${RootPaths.APP_V2_HOME}/${IN_HOME_BOOKED_VISIT_HISTORY_PATH}`}
            component={CaseHistoryPage}
          />
        </Switch>
      </InHomeCaseHistoryDataProvider>
    </InHomeVisitModalsDataProvider>
  );
}
